import { registerBlockType } from "@wordpress/blocks";
import { layout as icon } from "@wordpress/icons";
import metadata from "./block.json";
import "./style.scss";
import Edit from "./Edit";
import Save from "./save";

registerBlockType(metadata.name, {
  edit: Edit,
  save: Save,
  icon: {
    foreground: "#0061FE",
    src: icon,
  },
});
